import { getActivitiesSectorListAction } from "../../../../../Actions/LogicActions/CorporateAccount/RequestCorporateAccount/GetActivitiesSectorListAction";
import { getCitiesListAction } from "../../../../../Actions/LogicActions/CorporateAccount/RequestCorporateAccount/GetCitiesListAction";
import { IOnChangeFormFieldActionParams, onChangeFormFieldAction } from "../../../../../Actions/LogicActions/CorporateAccount/RequestCorporateAccount/OnChangeFormFieldAction";
import { saveRequestCorporateAccount } from "../../../../../Actions/LogicActions/CorporateAccount/RequestCorporateAccount/SaveRequestCorporateAccount";
import { getCountryCodesAction } from "../../../../../Actions/LogicActions/MyAccount/PersonalInformation/GetCountryCodesAction";
import { getContactCategoriesAction } from "../../../../../Actions/LogicActions/NeedHelp/GetContactCategoriesAction";
import { getCorporateAccountFaqsAction } from "../../../../../Actions/LogicActions/NeedHelp/GetCorporateAccountFaqsAction";
import { _eventBus } from "../../../../../core/events/EventBus";
import { StepDefinition } from "../../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../../../Lib/Utils/validationUtil";
import { corporateAccountTree } from "../../../../../Orchestrator/ConstantTree/CorporateAccount/CorporateAccountTree";
import { updateRecoilState } from "../../../../../Orchestrator/Recoils/Events/Recoil";
import { ISaveRequestCorporateAccountParams } from "../../../../../Orchestrator/Types/Interface/ActionParams/RequestCorporate";
import { IGetFaqListActionParams } from "../../../../../Orchestrator/Types/Interface/INeedHelp";
import { RequestCorporateAccountContext } from "../Context/RequestCorporateAccountContext";


class RequestCorporateAccount extends StepFlow {
    get stepName() { return "RequestCorporateAccount_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<IGetFaqListActionParams, void>({
                eventName: corporateAccountTree.Request.FAQ.Get,
                handler: async ({ data }) => {
                    getCorporateAccountFaqsAction.setParams(data!);
                    await getCorporateAccountFaqsAction.execute();
                },
            })
        );
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: corporateAccountTree.Request.CustomerContact.Categories.Get,
                handler: async () => {
                    await getContactCategoriesAction.execute();
                },
            })
        );
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: corporateAccountTree.Request.GetActivity,
                handler: async (payload) => {
                    await getActivitiesSectorListAction.execute();
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: corporateAccountTree.Request.GetCities,
                handler: async (payload) => {
                    await getCitiesListAction.execute();
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: corporateAccountTree.Request.GetCountryCode,
                handler: async (payload) => {
                    await getCountryCodesAction.execute();
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<IOnChangeFormFieldActionParams, void>({
                eventName: corporateAccountTree.Request.Field.onChange,
                handler: async ({ data }) => {
                    if (data) {
                        const context = this.getCtx<RequestCorporateAccountContext>("requestCorporateAccountContext")
                        if (context) {
                            context.oldDetails = {
                                ...context.oldDetails || {},
                                [data.name]: data.value
                            }
                            await onChangeFormFieldAction.setParams({
                                name: data.name,
                                value: data.value,
                                oldDetails: data.oldDetails || {}
                            })
                            await onChangeFormFieldAction.execute()
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<ISaveRequestCorporateAccountParams, void>({
                eventName: corporateAccountTree.Request.Button.Click,
                handler: async ({ data }) => {
                    if (data) {
                        await saveRequestCorporateAccount.setParams(data)
                        await saveRequestCorporateAccount.execute();
                        if (isActionRunSuccessfully(saveRequestCorporateAccount)) {
                            const result = saveRequestCorporateAccount.result!
                            if (result === "success") {

                            } else {
                                console.log("Request corporate account create fail")
                            }
                        }
                    }
                }
            })
        )
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: corporateAccountTree.Request.Page.Unmount,
                handler: async () => {
                    updateRecoilState("corporateFormSubmittedAtom", false)
                }
            })
        )
    }

    async onEventTearDown(): Promise<void> {
        updateRecoilState("corporateFormSubmittedAtom", false)
    }

    async onExecute(): Promise<void> {
        console.log("RequestCorporateAccount_Step Executed....................");
        _eventBus.emit({
            eventName: corporateAccountTree.Request.GetActivity
        })
        _eventBus.emit({
            eventName: corporateAccountTree.Request.GetCities
        })
        _eventBus.emit({
            eventName: corporateAccountTree.Request.GetCountryCode
        })
        _eventBus.emit({
            eventName: corporateAccountTree.Request.CustomerContact.Categories.Get
        })
        // _eventBus.emit({
        //     eventName: corporateAccountTree.Request.FlowStarted
        // })
        updateRecoilState("corporateAccountFlowStartedAtom", true)
    }
}

export const RequestCorporateAccountStepDeclaration = new StepDefinition({
    stepName: "RequestCorporateAccount_Step",
    stepClass: RequestCorporateAccount
});